export default "/shACCT.c6442e07bc9b77b4ad0687bcafcc3763.svg";